const schema = localStorage.getItem('schema')
export const basicFormData = () => ({
  inputData: {
    // user_type: "",
    first_name: "",
    last_name: "",
    role_id: "",
    branch_id: "",
    email_id: "",
    mobile_number: "",
    password: "",
    username: "",
    skill: null,
    // alt_mobile_number: null,
    // address: "",
    // company_id: null,
    // subcontractor_id: null,
    created_by: 1,
    updated_by: 1,
    is_active: true,
    // user_documents: [],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "user_masters",
    schema:schema,
    inputData: {
      first_name: "",
      last_name: "",
      username:"",
      skill:null,
      role_id: "",
      branch_id: "",
      email_id: "",
      mobile_number: "",
      password: "",
      // alt_mobile_number: "",
      // gst_no: "",
      // address: "",
      // subcontractor_id: null,
      created_by: null,
      updated_by: null,
      is_active: true,
    },
    moduleWhereCondition: {
      is_active: true,
    },
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "subcontractor",
    //     isModuleWhereConditionRequired: true,
    //   },
    //   {
    //     module: "user_documents",
    //     moduleAs: "user_documents",
    //     isModuleWhereConditionRequired: true,
    //   },
    // ],
  };
  const deleteRelation = [
    {
      modelName: "user_masters",
      moduleAs: "subcontractor",
      foreignKey: "subcontractor_id",
    },
    {
      modelName: "user_documents",
      moduleAs: "user_documents",
      foreignKey: "user_id",
    },
  ];

  const navigatePage = { back: "/user-list" };

  const headerName = "User";

  const validationType = "UserCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const userTypeList = [
    {
      options: [
        { label: "Bermad User", value: 1 },
        { label: "Subcontractor", value: 2 },
        { label: "Customer", value: 3 },
        { label: "Subcontractor sub user", value: 4 },
      ],
    },
  ];
  const dependentDropdownData = [
    {
      module_name: "role_masters",
      initialPayload: { modelName: "role_masters" },
      isOtherDependentOnThis: false,
      patchFieldName: "role_name",
      dropdownDataValue: "role_id",
      endPoint: "/listRole",
    },
  ];
  const multiModuleFormModules = [
    {
      moduleName: "user_documents",
      formFields: [
        {
          label: "Document Name",
          name: "document",
          type: "text",
          placeholder: "Document name",
          asterisk: true,
        },

        {
          label: "File",
          name: "file",
          type: "file",
          placeholder: "Document",
        },
      ],
    },
    {
      moduleName: "subcontractor",
      formFields: [
        {
          label: "First Name",
          name: "first_name",
          type: "text",
          placeholder: "User name",
        },
        {
          label: "Last Name",
          name: "last_name",
          type: "text",
          placeholder: "User name",
        },
        {
          label: "Email Id",
          name: "email_id",
          type: "text",
          placeholder: "Email Id",
        },
        {
          label: "Mobile Number",
          name: "mobile_number",
          type: "text",
          placeholder: "Mobile Number",
        },
        {
          label: "Password",
          name: "password",
          type: "password",
          placeholder: "Password",
        },
      ],
    },
  ];

  const multiModuleNames = multiModuleFormModules.map(
    (module) => module.moduleName
  );

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    userTypeList,
    multiModuleNames,
    multiModuleFormModules,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    deleteRelation,
  };
};

export const listPageData = (type) => {
  const payload = {
    modelName: "user_masters",
    schema:schema,
    "include": [
      {
        "model": "role_masters",
        "as": "role"
      },
      {
        "model": "branch_masters",
        "as": "branch"
      }
    ]
    // whereCondition: {
    //   user_type: { in: type ? [type] : [1, 2, 3] },
    // },

    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "subcontractor",
    //   },
    //   {
    //     module: "role_masters",
    //     moduleAs: "role_masters",
    //   },
    //   {
    //     module: "company_masters",
    //     moduleAs: "company_masters",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr. No", value: "index" },
    { label: "Role", value: "role.role_name" },
    { label: "Branch", value: "branch.branch_name" },
    { label: "First Name", value: "first_name" },
    { label: "Last Name", value: "last_name" },
    // { label: "Role", value: "role_masters.role_name" },
    { label: "Email ID", value: "email_id" },
    // { label: "Mobile Number", value: "mobile_number" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/user-create",
    edit: "/user-create",
    view: "/user-view",
  };

  const searchfields = [
    "user_masters.first_name",
    "user_masters.last_name",
    "user_masters.email_id",
    "user_masters.mobile_number",
    "company_masters.company_name",
  ];

  const headerName = "User";
  const endpoint = "/getRecords";
  const exportFileName = "userData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "user_masters",
  whereCondition: {
    user_type: { in: [1] },
  },

  relations: [
    {
      module: "user_masters",
      moduleAs: "createdBy",
    },
    {
      module: "user_masters",
      moduleAs: "updatedBy",
    },
    {
      module: "user_masters",
      moduleAs: "subcontractor",
    },
    {
      module: "role_masters",
      moduleAs: "role_masters",
    },
    {
      module: "company_masters",
      moduleAs: "company_masters",
    },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
